<template>
    <div class="container" v-loading="tableing">
        
        <div class="ciIcon">
            <img v-if="pay.status=='0000'" src="../../../static/images/signOkicon.png" alt="" srcset="">
            <img v-else src="../../../static/images/listNotNotxt.png" alt="" srcset="">
        </div>
        <div class="titleTxt">
            <p class="t1"><b :class="[pay.status=='0000'?'suc':'red']">{{pay.result}}</b></p>
            <p class="t2"><em>订单金额：</em><span>{{pay.orderfee||'0'}} 元</span></p>
            <p class="t2"><em>订单时间：</em><span>{{pay.responsetime||'-'}}</span></p>
            <p class="t2"><em>支付订单号：</em><span>{{pay.merchantorderid||'-'}}</span></p>
            <p class="t2"><em>备注：</em><span>{{pay.statusText||'-'}}</span></p>
        </div>
        <div class="nextBox">
            <el-button class="goBefter" type="primary" @click="nextClick()" :disabled="times>0"> {{times>0?`${times} s`:'查看订单列表'}} </el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name:"payOk",
        data() {
            return {
                tableing:false,
                pay:{
                    status:'',
                    result:'',
                    orderfee:'',
                    responsetime:'',
                    merchantorderid:'',
                    statusText:'',
                },
                times:0,
                timer:null,
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        beforeDestroy() {
            this.timer && window.clearTimeout(this.timer)
        },
        computed:{},
        mounted(){
            this.verifyUrlPro()
        },
        methods:{
            verifyUrlPro(){
                // 1.判断url 是否为/index.html#/payOk 路径,由于商联跳转的payOk偶尔会将参数拼接在连接中间
                let url = window.location.href
                console.log('cs',!(url.includes('/index.html#/payOk')))
                if(!(url.includes('/index.html#/payOk'))){
                    let arr = url.split('/index.html')
                    const paramZt = arr[1].split('#/payOk')
                    window.location.href = `${arr[0]}/index.html#/payOk${paramZt}`
                    return
                }
                this.statusAnalyze()
            },
            statusAnalyze(){
                let urlPro = this.$route.query
                this.pay.status = urlPro.returncode
                this.pay.result = urlPro.returncode=='0000'?'支付成功':'支付失败'
                this.pay.orderfee = urlPro.orderfee
                this.pay.responsetime = urlPro.responsetime
                this.pay.merchantorderid = urlPro.merchantorderid
                this.pay.statusText = this.slCodeFun(urlPro.returncode)

                // 开始倒计时 5s
                if(urlPro.returncode=='0000')
                this.startTimer5()
            },
            startTimer5(){
                let that = this
                that.times = 10
                that.timer && window.clearTimeout(that.timer)
                that.timer5Come()
            },
            timer5Come(){
                let that = this
                if(that.times > 0) {
                    that.times--;
                    that.timer = window.setTimeout(function () {that.timer5Come();}, 1000);
                }else{
                    that.timer && window.clearTimeout(that.timer);
                    that.times = 0
                }
            },
            nextClick(){
                this.$router.push({
                    path: '/myExamList',
                    query: {tab:2}
                })
            },
            slCodeFun(code){
                let obj = {
                    '0000':'交易成功',
                    '1001':'参数验签失败',
                    '1002':'系统异常',
                    '1003':'网络异常',
                    '1004':'字段值格式不正确',
                    '1005':'字段不能为空',
                    '1006':'字段值超长',
                    '1007':'系统内部技术流程校验错误',
                    '1008':'含有未实现的方法',
                    '1009':'执行业务流程有商未配置数据错误',
                    '1010':'操作数据库异常请查询参数',
                    '1011':'无通道错误映射配置',
                    '1012':'原渠道流水号重复',
                    '1013':'该商户没有配置微信公众号appid',
                    '1014':'发送获取微信公众号消息模板通道异常',
                    '1015':'字段名称校验不符',
                    '1016':'避免重复付款，该订单暂不允许支付',
                    '2001':'渠道流水号重复',
                    '2002':'为系统黑名单',
                    '2003':'不支持此证件类型',
                    '2004':'生成流水号错误',
                    '2005':'查询不到相关数据',
                    '2006':'校验不通过数据不一致',
                    '2007':'数据不正确',
                    '2008':'无通道可用',
                    '2009':'暂不支持此设备访问，目前只支持移动设备或者微信进行访问',
                    '2010':'该平台无权限访问请检查配置',
                    '2011':'加密使用的key值不正确',
                    '2012':'商户和平台不正确',
                    '2013':'商户未开通授权产品',
                    '2014':'解约失败',
                    '2015':'没有查找到签约的协议号',
                    '2016':'该用户唯一编号不存在',
                    '2017':'无支付方式可用',
                    '2018':'系统内部错误-清算行配置有误',
                    '2019':'包含已签约产品',
                    '2020':'订单支付超时',
                    '2021':'用户主动放弃付款',
                    '2022':'验证码验证失败',
                    '2023':'不允许签约上送的产品',
                    '2024':'获取短信验证码失败',
                    '2025':'验证码',
                    '2026':'系统内部错误-银行编码映射配置有误或不支持此银行卡',
                    '2027':'不支持信用卡',
                    '2028':'系统内部错误-通道证件类型陪配置有误',
                    '2029':'用户协议号和银行卡不能同时为空',
                    '2030':'通联通道必须使用四要素进行支付 请关闭此商户通联通道',
                    '2031':'获取验证码失败—操作频繁请一分钟后重试',
                    '2032':'银行卡余额不足',
                    '2033':'计费错误',
                    '2034':'原商户订单已成功过',
                    '2035':'微信获取用户信息（openid）失败',
                    '2036':'调用通道异常',
                    '2037':'通道处理失败{0}',
                    '3001':'扣款中',
                    '4001':'没有查询到相关数据',
                    '4002':'通道回调失败',
                    '4003':'暂不支持该银行，请检查或更换其他银行卡重试',
                    '4004':'银行卡前六位对应两个卡bin暂不做处理',
                    '4005':'系统卡bin信息配置有误请联系管理员',
                }
                return obj[code]
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
        .ciIcon{
            position: absolute;
            top: 0;
            height: 40%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img{
                height: 70%;
                object-fit: cover;
            }
        }
        .suc{color: #1fca6e;}
        .red{color:red}
        .titleTxt{
            position: absolute;
            top: 41%;
            width: 100%;
            text-align: left;
            box-sizing: border-box;
            padding-left: 30%;
            .t1{
                font-size: 30px;
                box-sizing: border-box;
                padding-left: 20%;
                margin-bottom: 25px;
            }
            .t2{
                em{
                    width: 98px;
                    text-align: right;
                    display: inline-block;
                }
                span{
                    color: #000;
                    font-weight: bold;
                    font-size: 18px;
                }
            }
        }
        .nextBox{
            position: absolute;
            top: 75%;
            width: 100%;
            text-align: center;
            .goBefter{
                width: 330px;
                // background-color: #1D4BAF;
                // color: #fff;
                font-weight: bold;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/myExamList/payOk.vue